import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

// Schriften selbst gehostet ueber @fontsource. Kein Google-Fonts-CDN: fuer ein
// deutsches Unternehmen ist der Fremd-Request an einen US-Dienst kein Detail,
// sondern DSGVO-relevant.
// Archivo wird mit der Breitenachse geladen (wdth.css statt index.css) — ohne
// sie liesse sich die breite, quadratische Anmutung der Wortmarke nicht setzen.
import '@fontsource-variable/inter'
import '@fontsource-variable/archivo/wdth.css'
import '@fontsource-variable/jetbrains-mono'

// Reihenfolge ist bindend: Seeds, dann semantische Tokens, dann Basis, dann
// Hilfsklassen. Wer das umstellt, bekommt undefinierte Custom Properties.
import './styles/brand.css'
import './styles/tokens.css'
import './styles/base.css'
import './styles/utilities.css'

import { App } from './App'

const container = document.getElementById('root')
if (!container) {
  throw new Error('#root fehlt in index.html')
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
